export function redirectToCustomerTimeline(applicationID: string): void {
  window.open(`/auto-refi/${applicationID}/linha-do-tempo`, '_blank')
}
